import { render, staticRenderFns } from "./SampleDataAnalysis.vue?vue&type=template&id=06244375&scoped=true&"
import script from "./SampleDataAnalysis.vue?vue&type=script&lang=js&"
export * from "./SampleDataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SampleDataAnalysis.vue?vue&type=style&index=0&id=06244375&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06244375",
  null
  
)

export default component.exports